import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from "reactstrap";
import Header from "components/Header/Header";
import Footer_New from "components/Footer-New/Footer-New";
import LoginModal from "components/LoginModal/LoginModal";
import { useLoginModal } from "../contexts/LoginModalContext";
import swal from "sweetalert";
import axios from "axios";
import { API_DONOR_DARAH, API_TIMEOUT } from "utils";

function RegistrasiPendonor() {
  const history = useHistory();
  // Hanya field yang dikirim ke data_donor
  const [formData, setFormData] = useState({
    nama: "",
    bloodTypes: "",
    desa: "",
    noHp: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { isOpen, toggleModal } = useLoginModal();
  const [listBloodTypes, setListBloodTypes] = useState([]);
  const [listDesa, setListDesa] = useState([]);
  const [wablasConfig, setWablasConfig] = useState({
    url: "",
    tokenwhatsapp: "",
    secret_key: "",
  });

  React.useEffect(() => {
    const fetchOptions = async () => {
      try {
        const resBT = await axios.get(API_DONOR_DARAH + "bloodtypes/", {
          timeout: API_TIMEOUT,
        });
        if (resBT.data?.success) {
          setListBloodTypes(resBT.data.data || []);
        }
      } catch (err) {
        console.error("Error fetch bloodtypes:", err);
      }

      try {
        const resDesa = await axios.get(API_DONOR_DARAH + "desa/", {
          timeout: API_TIMEOUT,
        });
        if (resDesa.data?.success) {
          setListDesa(resDesa.data.data || []);
        }
      } catch (err) {
        console.error("Error fetch desa:", err);
      }
    };
    fetchOptions();
    getWablasConfig();
  }, []);

  // Fungsi untuk mengambil konfigurasi wablas aktif
  const getWablasConfig = async () => {
    try {
      const response = await axios.get(`${API_DONOR_DARAH}wablas/active`, {
        timeout: API_TIMEOUT,
      });

      if (response.data?.success === 1 && response.data.data) {
        setWablasConfig({
          url: response.data.data.url,
          tokenwhatsapp: response.data.data.tokenwhatsapp,
          secret_key: response.data.data.secret_key || "",
        });
      } else {
        console.log("Tidak ada konfigurasi wablas aktif");
      }
    } catch (error) {
      console.error("Error fetching wablas config:", error);
    }
  };

  // Fungsi untuk mengirim pesan WhatsApp terima kasih
  const kirimPesanTerimaKasih = async (nama, noHp) => {
    try {
      // Ambil konfigurasi wablas
      let url = wablasConfig.url;
      let token = wablasConfig.tokenwhatsapp;
      let secretKey = wablasConfig.secret_key || "";
      console.log(wablasConfig);
      // Jika belum ada konfigurasi, ambil dari database
      if (!url || !token) {
        const configResponse = await axios.get(
          `${API_DONOR_DARAH}wablas/active`,
          {
            timeout: API_TIMEOUT,
          }
        );
        if (configResponse.data?.success && configResponse.data.data) {
          url = configResponse.data.data.url;
          token = configResponse.data.data.tokenwhatsapp;
          secretKey = configResponse.data.data.secret_key || "";
          setWablasConfig({
            url,
            tokenwhatsapp: token,
            secret_key: secretKey,
          });
        } else {
          console.log(
            "Tidak ada konfigurasi wablas aktif, skip pengiriman pesan"
          );
          return;
        }
      }

      // Format nomor HP
      let phoneNumber = noHp.replace(/\D/g, "");
      if (phoneNumber.startsWith("0")) {
        phoneNumber = "62" + phoneNumber.substring(1);
      } else if (!phoneNumber.startsWith("62")) {
        phoneNumber = "62" + phoneNumber;
      }

      // Link aplikasi
      const appLink = "https://donor-darah.rotendaokab.go.id";

      // Format pesan terima kasih
      const pesan = `Halo *${nama}*,

Terima kasih telah mendaftar sebagai pendonor darah di Sistem Donor Darah Dinas Kesehatan Kab. Rote Ndao.

Kami akan menginformasikan Anda terkait kebutuhan donor darah di masa depan melalui nomor WhatsApp ini.

🔗 *Akses Aplikasi Donor Darah:*
${appLink}

Kami sangat menghargai kepedulian dan kebaikan hati Anda untuk membantu sesama yang membutuhkan.

Terima kasih atas partisipasi Anda.

🙏🙏🙏
*Sistem Donor Darah - Dinkes Kab. Rote Ndao*`;

      // Kirim pesan melalui backend endpoint
      const response = await axios.post(
        `${API_DONOR_DARAH}wablas/send-message`,
        {
          url: url,
          token: token,
          secret_key: secretKey,
          phone: phoneNumber,
          message: pesan,
          flag: "instant",
        },
        {
          timeout: API_TIMEOUT,
        }
      );

      if (response.data?.success === 1) {
        console.log("✅ Pesan terima kasih berhasil dikirim ke", nama);
        console.log("Response:", response.data);
      } else {
        console.error("❌ Gagal mengirim pesan:", response.data?.message);
      }
    } catch (error) {
      console.error("❌ Error mengirim pesan terima kasih:", error);
      if (error.response) {
        console.error("Error response:", {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers,
        });
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
      // Tidak tampilkan error ke user, karena registrasi sudah berhasil
      // Hanya log di console untuk debugging
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.nama.trim()) newErrors.nama = "Nama wajib diisi";
    if (!formData.bloodTypes)
      newErrors.bloodTypes = "Golongan darah wajib dipilih";
    if (!formData.noHp.trim()) newErrors.noHp = "Nomor HP wajib diisi";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      swal("Error", "Mohon lengkapi semua field yang wajib diisi", "error");
      return;
    }

    setIsSubmitting(true);
    // Map ke kolom data_donor
    const payload = {
      nama: formData.nama,
      bloodTypes: formData.bloodTypes,
      desa: formData.desa || null,
      noHp: formData.noHp,
    };

    try {
      const res = await axios.post(API_DONOR_DARAH + "donatur", payload, {
        timeout: API_TIMEOUT,
      });
      if (res.data?.success) {
        // Kirim pesan WhatsApp terima kasih setelah registrasi berhasil
        if (formData.noHp && formData.nama) {
          // Kirim pesan secara async, tidak perlu menunggu
          kirimPesanTerimaKasih(formData.nama, formData.noHp).catch((err) => {
            console.error("Gagal mengirim pesan terima kasih:", err);
          });
        }

        swal(
          "Berhasil!",
          res.data.message || "Registrasi pendonor berhasil disimpan.",
          "success"
        );
        // Reset form
        setFormData({
          nama: "",
          bloodTypes: "",
          desa: "",
          noHp: "",
        });
      } else {
        swal("Error", res.data?.message || "Gagal menyimpan data", "error");
      }
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Terjadi kesalahan, coba lagi";
      swal("Error", msg, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <LoginModal isOpen={isOpen} toggle={toggleModal} />
      <div
        className="content"
        style={{
          margin: 20,
          background: "#ffffff",
          minHeight: "100vh",
          padding: "20px 0",
        }}
      >
        {/* Header Section */}
        <Row style={{ marginBottom: "40px" }}>
          <Col xs="12">
            <Card
              style={{
                background: "linear-gradient(135deg, #e63946 0%, #d62828 100%)",
                borderRadius: "20px",
                border: "none",
                boxShadow: "0 4px 25px rgba(230, 57, 70, 0.2)",
                padding: "40px",
                color: "#ffffff",
              }}
            >
              <h1
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "300",
                  marginBottom: "15px",
                }}
              >
                📝 Registrasi Calon Pendonor
              </h1>
              <p style={{ fontSize: "1.1rem", opacity: 0.95, margin: 0 }}>
                Daftarkan diri Anda sebagai pendonor darah dan bantu selamatkan
                nyawa
              </p>
            </Card>
          </Col>
        </Row>

        {/* Form Section - data_donor */}
        <Row>
          <Col xs="12" lg="8" style={{ margin: "0 auto" }}>
            <Card
              style={{
                borderRadius: "20px",
                border: "none",
                boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
              }}
            >
              <CardHeader
                style={{
                  background: "#ffffff",
                  borderBottom: "2px solid #f1f3f5",
                  padding: "30px",
                }}
              >
                <CardTitle
                  tag="h4"
                  style={{
                    color: "#2d3436",
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "1.5rem",
                  }}
                >
                  Formulir Registrasi (data pendonor)
                </CardTitle>
              </CardHeader>
              <CardBody style={{ padding: "30px" }}>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label
                          for="nama"
                          style={{ fontWeight: "500", color: "#2d3436" }}
                        >
                          Nama Lengkap{" "}
                          <span style={{ color: "#e63946" }}>*</span>
                        </Label>
                        <Input
                          type="text"
                          name="nama"
                          id="nama"
                          value={formData.nama}
                          onChange={handleChange}
                          invalid={!!errors.nama}
                          style={{
                            borderRadius: "10px",
                            border: errors.nama
                              ? "2px solid #e63946"
                              : "1px solid #e9ecef",
                            padding: "12px 15px",
                          }}
                        />
                        {errors.nama && (
                          <div
                            style={{
                              color: "#e63946",
                              fontSize: "0.875rem",
                              marginTop: "5px",
                            }}
                          >
                            {errors.nama}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label
                          for="noHp"
                          style={{ fontWeight: "500", color: "#2d3436" }}
                        >
                          Nomor HP <span style={{ color: "#e63946" }}>*</span>
                        </Label>
                        <Input
                          type="tel"
                          name="noHp"
                          id="noHp"
                          value={formData.noHp}
                          onChange={handleChange}
                          invalid={!!errors.noHp}
                          style={{
                            borderRadius: "10px",
                            border: errors.noHp
                              ? "2px solid #e63946"
                              : "1px solid #e9ecef",
                            padding: "12px 15px",
                          }}
                        />
                        {errors.noHp && (
                          <div
                            style={{
                              color: "#e63946",
                              fontSize: "0.875rem",
                              marginTop: "5px",
                            }}
                          >
                            {errors.noHp}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label
                          for="bloodTypes"
                          style={{ fontWeight: "500", color: "#2d3436" }}
                        >
                          Golongan Darah{" "}
                          <span style={{ color: "#e63946" }}>*</span>
                        </Label>
                        <Input
                          type="select"
                          name="bloodTypes"
                          id="bloodTypes"
                          value={formData.bloodTypes}
                          onChange={handleChange}
                          invalid={!!errors.bloodTypes}
                          style={{
                            borderRadius: "10px",
                            border: errors.bloodTypes
                              ? "2px solid #e63946"
                              : "1px solid #e9ecef",
                            padding: "12px 15px",
                          }}
                        >
                          <option value="">Pilih</option>
                          {listBloodTypes.map((bt) => (
                            <option
                              key={bt.bloodTypeID}
                              value={bt.golonganDarah}
                            >
                              {bt.golonganDarah}
                            </option>
                          ))}
                        </Input>
                        {errors.bloodTypes && (
                          <div
                            style={{
                              color: "#e63946",
                              fontSize: "0.875rem",
                              marginTop: "5px",
                            }}
                          >
                            {errors.bloodTypes}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label
                          for="desa"
                          style={{ fontWeight: "500", color: "#2d3436" }}
                        >
                          Desa/Alamat
                        </Label>
                        <Input
                          type="select"
                          name="desa"
                          id="desa"
                          value={formData.desa}
                          onChange={handleChange}
                          style={{
                            borderRadius: "10px",
                            border: "1px solid #e9ecef",
                            padding: "12px 15px",
                          }}
                        >
                          <option value="">Pilih Desa</option>
                          {listDesa.map((d) => (
                            <option key={d.id || d.desa} value={d.desa}>
                              {d.desa}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <div style={{ marginTop: "20px", textAlign: "right" }}>
                    <Button
                      color="primary"
                      type="submit"
                      disabled={isSubmitting}
                      style={{
                        padding: "12px 24px",
                        borderRadius: "10px",
                        minWidth: "180px",
                      }}
                    >
                      {isSubmitting ? "Mengirim..." : "Daftarkan"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <Footer_New />
    </>
  );
}

export default RegistrasiPendonor;
